export default __webpack_public_path__ + "static/media/notification-bell-icon.e978cdd0.svg";